import React, { useEffect, useState, useRef } from "react";
import "./header1.scss";
import { Link, useLocation, useParams, useHistory } from "react-router-dom";
import store from "../../../store";
import {
  FaAngleDown,
  FaSearch,
  FaHeart,
  FaTimes,
  FaShoppingCart,
  FaBars,
  FaUser,
} from "react-icons/fa";
import {
  getCartData,
  getLogout,
  userLogoff,
  getWishlist,
  viewOrderDetail,
  getDeals,
  getNewDeals,
  fetchImages,
  getAllProducts,
  getOrders,
} from "../../../actions";
import { fetchBestSeller } from "../../../actions/index";
import { connect } from "react-redux";
import { LazyLoadImage } from "react-lazy-load-image-component";
import axios from "axios";
import NavbarSearch from "./NavbarSearch";

const Header2 = ({
  getWishlists,
  sociallinks,
  cartData,
  mainScreenText,
  currencies,
  ChangeCurrences,
  appconfigs,
  categories,
  getallcategories,
}) => {
  const [show, setShow] = useState(false);
  const [showA, setShowA] = useState(false);
  const [dispAccount, setDispAccount] = useState(false);
  const [dispCurrunce, setDispCurrence] = useState(false);
  const cartRef = useRef(null);
  const accountRef = useRef(null);
  const currencyRef = useRef(null);
  const headerRef = useRef(null);
  const [drop, setDrop] = useState(false);
  const [profile, setprofile] = useState(false);
  const [data, setDaaataaa] = useState("");
  const [pageRoute, setPageRoute] = useState("");
  const [mobileSearch, setMobileSearch] = useState("");
  const history = useHistory();

  const handleMobileSearch = (e) => {
    if (e) e.preventDefault();
    if (mobileSearch && mobileSearch.trim()) {
      history.push({
        pathname: `${process.env.PUBLIC_URL}/products/Products-all`,
        search: `?search=${encodeURIComponent(mobileSearch.trim())}`,
      });
    }
  };

  // Keep CSS variable in sync with actual header height
  useEffect(() => {
    const updateHeaderHeight = () => {
      if (headerRef.current) {
        const h = headerRef.current.getBoundingClientRect().height;
        if (h > 0) {
          document.documentElement.style.setProperty("--header-height", `${h}px`);
        }
      }
    };
    // Run immediately
    updateHeaderHeight();
    // Run again after short delay to catch logo load from API
    const t1 = setTimeout(updateHeaderHeight, 300);
    const t2 = setTimeout(updateHeaderHeight, 1000);
    window.addEventListener("resize", updateHeaderHeight);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      window.removeEventListener("resize", updateHeaderHeight);
    };
  }, []);
  const [dataaaaaaaa, setDatataa] = useState("");
  const [stleeeeew, setStleeee] = useState(null);
  const params = useParams();
  const locaaaa = useLocation();

  // New states for subcategories
  const [subCategoriesMap, setSubCategoriesMap] = useState({});
  const [expandedMobileCat, setExpandedMobileCat] = useState(null); // For mobile accordion

  // Sort categories by position ascending (1 first, then 2, 3...)
  const sortedCategories =
    categories && categories.length > 0
      ? [...categories].sort(
          (a, b) => (Number(a?.position) || 0) - (Number(b?.position) || 0)
        )
      : [];

  useEffect(() => {
    if (
      /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      )
    ) {
      setDrop(true);
    } else if (localStorage.getItem("changeCurrencies") == "EUR") {
      setDatataa(localStorage.getItem("changeCurrencies"));
    } else if (localStorage.getItem("changeCurrencies") == "USD") {
      setDatataa(localStorage.getItem("changeCurrencies"));
    } else if (localStorage.getItem("changeCurrencies") == "PKR") {
      setDatataa(localStorage.getItem("changeCurrencies"));
    }
    localStorage.setItem(
      "defaultDataaa",
      localStorage.getItem("changeCurrencies"),
    );
  }, []);


  useEffect(() => {
    function handleClickOutside(e) {
      if (cartRef.current && !cartRef.current.contains(e.target)) {
        setprofile(false);
      }
      if (accountRef.current && !accountRef.current.contains(e.target)) {
        setDispAccount(false);
      }
      if (currencyRef.current && !currencyRef.current.contains(e.target)) {
        setDispCurrence(false);
      }
    }
    if (profile || dispAccount || dispCurrunce) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [profile, dispAccount, dispCurrunce]);

  useEffect(() => {
    setDaaataaa(localStorage.getItem("changeCurrencies"));
    store.dispatch(fetchImages());
    // setTimeout(() => {
    // this.setState({ apicondtionn: true })
    // localStorage.setItem("apiupdate", this.state.apicondtionn)
    // store.dispatch(getAllProducts());
    store.dispatch(getDeals());
    store.dispatch(getNewDeals());
    if (localStorage.getItem("customerData")) {
      store.dispatch(getOrders());
      store.dispatch(viewOrderDetail());
      store.dispatch(getCartData());
    }
    localStorage.setItem(
      "defaultDataaa",
      localStorage.getItem("changeCurrencies"),
    );
  }, [localStorage.getItem("changeCurrencies")]);
  useEffect(() => {
    if (
      ChangeCurrences &&
      ChangeCurrences.length &&
      !localStorage.getItem("changeCurrencies")
    ) {
      let currency_code = ChangeCurrences.map((v) => v.code);

      axios
        .get("https://ipapi.co/json/")
        .then((res) => {
          let current_currecncy = res.data?.currency;

          if (currency_code.includes(current_currecncy)) {
            localStorage.setItem("changeCurrencies", current_currecncy);
            localStorage.setItem("defaultDataaa", current_currecncy);

            // console.log("1", currency_code, current_currecncy)
          } else if (currency_code.includes("USD")) {
            localStorage.setItem("changeCurrencies", "USD");
            localStorage.setItem("defaultDataaa", "USD");
            // console.log("2", currency_code, current_currecncy)
          } else {
            localStorage.setItem("changeCurrencies", currency_code[0]);
            localStorage.setItem("defaultDataaa", currency_code[0]);
            // console.log("3", currency_code, current_currecncy)
          }
        })
        .catch(() => {
          if (currency_code.includes("PKR")) {
            localStorage.setItem("changeCurrencies", "PKR");
            localStorage.setItem("defaultDataaa", "BHD");
          } else if (currency_code.includes("USD")) {
            localStorage.setItem("changeCurrencies", "USD");
            localStorage.setItem("defaultDataaa", "USD");
          } else {
            localStorage.setItem("changeCurrencies", currency_code[0]);
            localStorage.setItem("defaultDataaa", currency_code[0]);
          }
        });
    }
  }, [ChangeCurrences]);

  useEffect(() => {
    if (localStorage.getItem("customerData")) {
      store.dispatch(getCartData());
      store.dispatch(getWishlist());
    }
  }, [pageRoute]);

  useEffect(() => {
    setPageRoute(window.location.pathname);
  }, []);

  const colorCodes = localStorage.getItem("color_theme");
  let parsedColorCodes = JSON.parse(colorCodes);
  let appconfig =
    parsedColorCodes && parsedColorCodes !== null
      ? parsedColorCodes
      : appconfigs;

  function handleClick(e) {
    document.querySelector(".loader-wrapper").style = "display: block";
    e.preventDefault();
    store.dispatch(getLogout());
    store.dispatch(userLogoff([]));
    localStorage.clear();
  }

  let item_lenght =
    cartData && cartData.items_qty ? cartData.items_qty.length : 0;
  let final_lenght =
    cartData && cartData.items_qty
      ? cartData.items_qty.substring(0, item_lenght - 5)
      : 0;

  useEffect(() => {
    if (!getallcategories?.data || !categories?.length) return;

    const subMap = {};

    categories.forEach((cat) => {
      subMap[cat.id] = getallcategories.data
        .filter((subCat) => subCat.parent_id === cat.id)
        .sort((a, b) => a?.position - b?.position); // 🔥 Descending order
    });

    setSubCategoriesMap(subMap);
  }, [getallcategories, categories]);

  useEffect(() => {
    const customStyle = sociallinks?.nav_style;
    if (customStyle) {
      try {
        const styleObject = JSON.parse(customStyle);
        setStleeee(styleObject);
      } catch (error) {
        console.error("Error parsing nav_style:", error);
      }
    }
  }, [sociallinks?.nav_style]);

  const styleString = sociallinks?.width ?? ""; // Provide a default value if sociallinks?.width is undefined
  const widthh = styleString.match(/width:\s*([^,]+)/)?.[1] || "";
  const heightt = styleString.match(/height:\s*([^,]+)/)?.[1] || "";

  const styleee = { widthh, heightt };
  return (
    <>
      <header ref={headerRef} className="header_header1 trans_300" style={{ zIndex: 9999999 }}>
        {/* <!-- Top Navigation - hidden --> */}
        <div className="top_nav_header1" style={{ display: "none" }}>
          <div className="container_header1">
            <div className="row">
              <div className="col-md-6 text-center">
                {/* <div
                  className="top_nav_left_header1"
                  style={{
                    display:
                      mainScreenText &&
                        mainScreenText.main_text === "none" &&
                        mainScreenText.sub_text === "none"
                        ? "none"
                        : "block",
                  }}
                >
                  {mainScreenText && mainScreenText?.main_text}{" "}
                  {mainScreenText && mainScreenText?.sub_text ? "|" : null}{" "}
                  {mainScreenText && mainScreenText?.sub_text}
                </div> */}
                <div
                  className="top_nav_left_header1"
                  style={{
                    display:
                      mainScreenText &&
                        mainScreenText.main_text === "none" &&
                        mainScreenText.sub_text === "none"
                        ? "none"
                        : "block",
                  }}
                >
                  <span>{mainScreenText && mainScreenText?.main_text}</span>
                  {mainScreenText && mainScreenText?.sub_text && (
                    <>
                      <span style={{ margin: "0 20px" }}>|</span>
                      <span>{mainScreenText?.sub_text}</span>
                    </>
                  )}
                </div>
              </div>
              <div className="col-md-6 text-right">
                <div className="top_nav_right_header1">
                  <ul className="top_nav_menu_header1">
                    <li className="currency_header1">
                      <a
                        onClick={() => {
                          setPageRoute(window.location.pathname);
                          setDispCurrence(!dispCurrunce);
                        }}
                        style={{
                          color: "rgb(255, 255, 255)",
                          fontWeight: 500,
                          cursor: "pointer",
                          fontWeight: "600",
                        }}
                      >
                        {localStorage.getItem("changeCurrencies") || "BHD"}
                        <FaAngleDown
                          style={{
                            fontSize: "12px", // size adjust kar sakta hai
                            marginLeft: "4px",
                            transition: "transform 0.2s", // rotate effect ke liye optional
                            transform: dispCurrunce
                              ? "rotate(180deg)"
                              : "rotate(0deg)", // dropdown open/close pe arrow up/down
                          }}
                        />
                      </a>
                      <ul
                        className="account_selection_header1"
                        style={
                          dispCurrunce
                            ? {
                              zIndex: 9999,
                              visibility: "visible",
                              display: "block",
                              opacity: 1,
                              top: "100%",
                              width: "102%",
                            }
                            : {
                              zIndex: 9999,
                              visibility: "hidden",
                              display: "none",
                              opacity: 0,
                              top: "100%",
                              width: "102%",
                            }
                        }
                      >
                        <>
                          {ChangeCurrences &&
                            ChangeCurrences.length !== 0 &&
                            ChangeCurrences.map((i, v) => {
                              return (
                                <li
                                  className="currency_header1"
                                  key={i + v}
                                  style={{
                                    color: "#232530",
                                    fontSize: "14px",
                                    cursor: "pointer",
                                    backgroundColor: "white",
                                    borderColor: "white",
                                  }}
                                  onClick={() => {
                                    setPageRoute("/dashboard");
                                    localStorage.setItem(
                                      "defaultDataaa",
                                      i?.code,
                                    );
                                    setDispCurrence(!dispCurrunce);
                                    localStorage.setItem(
                                      "changeCurrencies",
                                      i?.code,
                                    );
                                    window.location.reload();

                                    // setDaaataaa(i?.code)
                                    i !== data && setDaaataaa(i?.code);
                                  }}
                                >
                                  {i?.code}
                                </li>
                              );
                            })}
                        </>
                        {/* <>
	<li style={{ color: '#232530', fontSize: '14px', cursor: "pointer" }} onClick={() => {
		setPageRoute('/login')
		setDispCurrence(!dispCurrunce)
	}}><Link to={`${process.env.PUBLIC_URL}/dashboard`}>EUR</Link></li>
	<li style={{ color: '#232530', fontSize: '14px', cursor: "pointer" }} onClick={() => {
		setPageRoute('/register')
		setDispCurrence(!dispCurrunce)
	}}><Link to={`${process.env.PUBLIC_URL}/dashboard`}>USD</Link></li>
</> */}
                      </ul>
                    </li>

                    <li className="account_header1">
                      <a
                        onClick={() => {
                          setPageRoute(window.location.pathname);
                          setDispAccount(!dispAccount);
                        }}
                        style={{
                          color: "#fff",
                          fontWeight: 500,
                          cursor: "pointer",
                        }}
                      >
                        My Account
                        {/* <i className="fa fa-angle-down"></i> */}
                        <FaAngleDown
                          style={{
                            fontSize: "12px", // size adjust kar sakta hai
                            marginLeft: "4px",
                            transition: "transform 0.2s", // rotate effect ke liye optional
                            transform: dispAccount
                              ? "rotate(180deg)"
                              : "rotate(0deg)", // dropdown open/close pe arrow up/down
                          }}
                        />
                      </a>
                      <ul
                        className="account_selection_header1"
                        style={
                          dispAccount
                            ? {
                              zIndex: 9999,
                              visibility: "visible",
                              display: "block",
                              opacity: 1,
                              top: "100%",
                            }
                            : {
                              zIndex: 9999,
                              visibility: "hidden",
                              display: "none",
                              opacity: 0,
                              top: "100%",
                            }
                        }
                      >
                        {localStorage.getItem("customerData") ? (
                          <>
                            <li
                              onClick={() => {
                                setPageRoute("/dashboard");
                                setDispAccount(!dispAccount);
                              }}
                            >
                              <Link to={`${process.env.PUBLIC_URL}/dashboard`}>
                                Dashboard
                              </Link>
                            </li>
                            <li
                              onClick={() => {
                                setPageRoute("/myOrders");
                                setDispAccount(!dispAccount);
                              }}
                            >
                              <Link to={`${process.env.PUBLIC_URL}/myOrders`}>
                                My Orders
                              </Link>
                            </li>
                            <li
                              onClick={() => {
                                setPageRoute("/ChangePassword");
                                setDispAccount(!dispAccount);
                              }}
                            >
                              <Link
                                to={`${process.env.PUBLIC_URL}/ChangePassword`}
                              >
                                C Password
                              </Link>
                            </li>
                            <li
                              onClick={() => {
                                setDispAccount(!dispAccount);
                              }}
                            >
                              <Link
                                onClick={handleClick}
                                to={`${process.env.PUBLIC_URL}/`}
                              >
                                Logout
                              </Link>
                            </li>
                          </>
                        ) : (
                          <>
                            <li
                              onClick={() => {
                                setPageRoute("/login");
                                setDispAccount(!dispAccount);
                              }}
                            >
                              <Link to={`${process.env.PUBLIC_URL}/login`}>
                                Sign In
                              </Link>
                            </li>
                            <li
                              onClick={() => {
                                setPageRoute("/register");
                                setDispAccount(!dispAccount);
                              }}
                            >
                              <Link to={`${process.env.PUBLIC_URL}/register`}>
                                Register
                              </Link>
                            </li>
                          </>
                        )}
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- Main Navigation --> */}

        <div className="main_nav_container_header1">
          <div className="container_header1">
            <div className="row" style={{ margin: 0 }}>
              <div className="col-lg-12 text-right" style={{ padding: 0 }}>
                <nav className="navbar_header1" style={{ border: "none", outline: "none", boxShadow: "none", background: "transparent" }}>
                  <div className="navbar_top_row">
                    <div className="navbar_logo_area">
                      <Link
                        onClick={() => setPageRoute("/")}
                        to={`${process.env.PUBLIC_URL}/`}
                      >
                        {sociallinks && sociallinks?.logo ? (
                          <LazyLoadImage
                            width={widthh}
                            height={heightt}
                            className="logoW_header1"
                            src={sociallinks && sociallinks?.logo}
                            alt="Tradnity"
                          />
                        ) : (
                          <div className="skeleton-item skeleton-images"></div>
                        )}
                      </Link>
                    </div>
                  <ul className="navbar_menu_header1">
                    {/* Home */}
                    <li>
                      <Link
                        onClick={() => setPageRoute("/")}
                        className={
                          pageRoute === "/" || pageRoute === ""
                            ? "activeM_header1"
                            : "effects"
                        }
                        style={{ textDecoration: "none" }}
                        to={`${process.env.PUBLIC_URL}/`}
                      >
                        Home
                      </Link>
                    </li>
                    {/* All Products */}
                    <li>
                      <Link
                        onClick={() => setPageRoute("/products")}
                        className={
                          pageRoute === "/products"
                            ? "activeM_header1"
                            : "effects"
                        }
                        style={{ textDecoration: "none" }}
                        to={{
                          pathname: `/products/Products-all`,
                          state: { categories: {} },
                        }}
                      >
                        All Products
                      </Link>
                    </li>
                    {sortedCategories.slice(0, 6).map((m) => {
                      const subs = subCategoriesMap[m.id] || [];
                      const hasSubs = subs.length > 0;
                      return (
                        <li key={m.id} className={hasSubs ? "has-submenu" : ""}>
                          {/* <Link
                            to={{
                              pathname: "/products",
                              search: `?category=${m.id}`,
                              state: { categories: m },
                            }}
                            style={{ textDecoration: "none", fontSize: "12px" }}
                          > */}
                          <Link
                            to={{
                              pathname: `/products/${m.name.replace(
                                /\s+/g,
                                "-",
                              )}-${m.id}`,
                              state: { categories: m },
                            }}
                            style={{ textDecoration: "none" }}
                          >
                            {m.name}
                            {hasSubs && (
                              <FaAngleDown
                                style={{
                                  fontSize: "12px",
                                  marginLeft: "4px",
                                  transition: "transform 0.2s",
                                }}
                              />
                            )}
                          </Link>
                          {hasSubs && (
                            <ul className="submenu_header1">
                              {subs.map((sub) => (
                                <li key={sub.id}>
                                  <Link
                                    to={{
                                      pathname: `/products/${sub.name.replace(
                                        /\s+/g,
                                        "-",
                                      )}-${sub.id}`,
                                      state: { categories: sub },
                                    }}
                                    style={{ textDecoration: "none" }}
                                  >
                                    {sub.name}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      );
                    })}

                    {/* About */}
                    <li>
                      <Link
                        onClick={() => setPageRoute("/about-us")}
                        className={
                          pageRoute === "/about-us"
                            ? "activeM_header1"
                            : "effects"
                        }
                        style={{ textDecoration: "none" }}
                        to={`${process.env.PUBLIC_URL}/about-us`}
                      >
                        About
                      </Link>
                    </li>

                    {/* Contact */}
                    <li>
                      <Link
                        onClick={() => setPageRoute("/contact")}
                        className={
                          pageRoute === "/contact"
                            ? "activeM_header1"
                            : "effects"
                        }
                        style={{ textDecoration: "none" }}
                        to={`${process.env.PUBLIC_URL}/contact`}
                      >
                        Contact
                      </Link>
                    </li>
                  </ul>
                  <ul className="navbar_user_header1">
                    <li className="checkout_header1 mx-1 nav_search_desktop_item">
                      <NavbarSearch isMobile={false} />
                    </li>
                    <li className="checkout_header1 mx-1">
                      <div className="cartsia" ref={cartRef}>
                        <a
                          className="ancd ancx"
                          onClick={() => {
                            setPageRoute(window.location.pathname);
                            setprofile(!profile);
                          }}
                        >
                          <FaShoppingCart aria-hidden="true" />
                          {final_lenght && final_lenght !== 0 ? (
                            <span
                              id="checkout_items"
                              className="checkout_items"
                            >
                              {final_lenght}
                            </span>
                          ) : null}
                        </a>
                        <ul
                          className="cart-list_header1"
                          style={profile ? { display: "block" } : { display: "none" }}
                        >
                          {/* Scrollable items area */}
                          <div style={{ maxHeight: 280, overflowY: "auto", overflowX: "hidden" }}>
                            {/* Header */}
                            <div style={{
                              padding: "14px 18px",
                              borderBottom: "1px solid rgba(245, 185, 109, 0.15)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}>
                              <span style={{ fontSize: 13, fontWeight: 600, color: "#FCFEFD", letterSpacing: "0.5px", textTransform: "uppercase" }}>Your cart</span>
                              {cartData?.items?.length > 0 && (
                                <span style={{
                                  fontSize: 12, background: "rgba(245, 185, 109, 0.15)", color: "#F5B96D",
                                  padding: "2px 10px", borderRadius: 99, fontWeight: 500,
                                }}>
                                  {cartData.items.length} item{cartData.items.length > 1 ? "s" : ""}
                                </span>
                              )}
                            </div>

                            {cartData && cartData.items && cartData.items.length !== 0 ? (
                              cartData.items.map((item, index) => (
                                <li key={index} className="dats" style={{ display: "block", listStyle: "none" }}>
                                  <div style={{
                                    display: "flex", alignItems: "center", gap: 12,
                                    padding: "12px 16px",
                                    borderBottom: "1px solid rgba(252, 254, 253, 0.06)",
                                  }}>
                                    {/* Image */}
                                    <Link to={`${process.env.PUBLIC_URL}/product/${item?.parent_url !== null ? item.parent_url : item.product.url_key}`}>
                                      <div style={{
                                        width: 58, height: 58, borderRadius: 8,
                                        border: "1px solid rgba(245, 185, 109, 0.2)", background: "#151619",
                                        overflow: "hidden", flexShrink: 0,
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                      }}>
                                        {item.product !== "" && item.product.images[0].url ? (
                                          <LazyLoadImage
                                            alt="img"
                                            src={item?.product?.images[0]?.url}
                                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                          />
                                        ) : (
                                          <Placeholder />
                                        )}
                                      </div>
                                    </Link>

                                    {/* Info */}
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                      <Link to={`${process.env.PUBLIC_URL}/product/${item?.parent_url !== null ? item.parent_url : item.product.url_key}`}>
                                        <p style={{
                                          fontSize: 13, fontWeight: 600, color: "#FCFEFD",
                                          margin: "0 0 4px", lineHeight: "18px",
                                          whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                                        }}>
                                          {item.name}
                                        </p>
                                      </Link>
                                      <p style={{ fontSize: 12, color: "#F5B96D", fontWeight: 600, margin: 0 }}>{item.formated_price}</p>
                                    </div>

                                    {/* Quantity badge */}
                                    <div style={{
                                      flexShrink: 0, display: "flex", flexDirection: "column",
                                      alignItems: "center", gap: 3,
                                    }}>
                                      <span style={{ fontSize: 10, color: "rgba(252,254,253,0.5)", marginBottom: "2px", textTransform: "uppercase" }}>qty</span>
                                      <span style={{
                                        fontSize: 12, fontWeight: 600, color: "#FCFEFD",
                                        background: "rgba(255, 255, 255, 0.06)", border: "1px solid rgba(252, 254, 253, 0.12)",
                                        borderRadius: 6, width: 26, height: 22,
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                      }}>
                                        {item.quantity}
                                      </span>
                                    </div>
                                  </div>
                                </li>
                              ))
                            ) : (
                              <section className="cart-section section-b-space" style={{ padding: "32px 16px" }}>
                                <div className="container_header1">
                                  <div className="row">
                                    <div className="col-sm-12 empty-cart-cls text-center">
                                      <h4 className="headCart" style={{ color: "#FCFEFD", fontSize: "16px", marginBottom: "8px" }}><strong>Your Cart is Empty</strong></h4>
                                      <h6 style={{ color: "rgba(252, 254, 253, 0.6)", fontSize: "12px", margin: 0 }}>Explore more shortlist some items.</h6>
                                    </div>
                                  </div>
                                </div>
                              </section>
                            )}
                          </div>

                          {/* Footer: total + buttons */}
                          {cartData && cartData.items && cartData.items.length !== 0 && (
                            <li className="total dats" style={{ display: "block", listStyle: "none" }}>
                              <div style={{
                                borderTop: "1px solid rgba(245, 185, 109, 0.15)",
                                padding: "12px 16px 14px",
                              }}>
                                <div style={{
                                  display: "flex", alignItems: "center",
                                  justifyContent: "space-between", marginBottom: 12,
                                  width: "100%", gap: "16px",
                                }}>
                                  <span style={{ fontSize: 12, color: "rgba(252, 254, 253, 0.65)", textTransform: "uppercase", letterSpacing: "1px", flexShrink: 0 }}>Subtotal</span>
                                  <span style={{ fontSize: 14, fontWeight: 700, color: "#FCFEFD", textAlign: "right" }}>
                                    {cartData.formated_grand_total}
                                  </span>
                                </div>
                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                                  <Link
                                    to="/cart"
                                    onClick={() => setprofile(!profile)}
                                    style={{
                                      padding: "9px 0", fontSize: 13, fontWeight: 600,
                                      borderRadius: 8, border: "1px solid rgba(245, 185, 109, 0.35)",
                                      background: "transparent", color: "#FCFEFD",
                                      textAlign: "center", textDecoration: "none",
                                    }}
                                  >
                                    View Cart
                                  </Link>
                                  <Link
                                    to="/cart-sidebar"
                                    onClick={() => setprofile(!profile)}
                                    style={{
                                      padding: "9px 0", fontSize: 13, fontWeight: 600,
                                      borderRadius: 8, border: "none",
                                      background: "var(--accent, #F5B96D)", color: "#08090B",
                                      textAlign: "center", textDecoration: "none",
                                    }}
                                  >
                                    Checkout
                                  </Link>
                                </div>
                              </div>
                            </li>
                          )}
                        </ul>
                      </div>
                    </li>
                    {appconfig &&
                      appconfig?.navbar_wishlist &&
                      appconfig.navbar_wishlist === 1 ? (
                      <li className="checkout_header1 mx-1">
                        <Link
                          className="ancd ancx"
                          to={`${process.env.PUBLIC_URL}/wishlist`}
                        >
                          {/* <i className="fa fa-heart" aria-hidden="true"></i> */}
                          <FaHeart aria-hidden="true" />
                          {getWishlists && getWishlists.length !== 0 ? (
                            <span
                              id="checkout_items"
                              className="checkout_items"
                            >
                              {getWishlists.length}
                            </span>
                          ) : null}
                        </Link>
                      </li>
                    ) : null}

                    {/* My Account (Desktop) */}
                    <li className="checkout_header1 mx-1 nav_account_desktop_item" ref={accountRef}>
                      <div className="account_dropdown_wrapper">
                        <button
                          type="button"
                          className={`ancd ancx nav_account_btn ${dispAccount ? "active" : ""}`}
                          onClick={() => {
                            setDispAccount(!dispAccount);
                            setDispCurrence(false);
                            setprofile(false);
                          }}
                          title="My Account"
                          aria-label="My Account"
                        >
                          <FaUser aria-hidden="true" />
                        </button>
                        {dispAccount && (
                          <div className="account_dropdown_menu">
                            <div className="account_dropdown_header">
                              <span className="account_dropdown_title">
                                {localStorage.getItem("customerData") ? "My Account" : "Account"}
                              </span>
                              <span className="account_dropdown_subtitle">
                                {localStorage.getItem("customerData")
                                  ? "Manage account & orders"
                                  : "Sign in to your account"}
                              </span>
                            </div>
                            <ul className="account_dropdown_list">
                              {localStorage.getItem("customerData") ? (
                                <>
                                  <li>
                                    <Link
                                      to={`${process.env.PUBLIC_URL}/dashboard`}
                                      onClick={() => {
                                        setPageRoute("/dashboard");
                                        setDispAccount(false);
                                      }}
                                    >
                                      Dashboard
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      to={`${process.env.PUBLIC_URL}/myOrders`}
                                      onClick={() => {
                                        setPageRoute("/myOrders");
                                        setDispAccount(false);
                                      }}
                                    >
                                      My Orders
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      to={`${process.env.PUBLIC_URL}/ChangePassword`}
                                      onClick={() => {
                                        setPageRoute("/ChangePassword");
                                        setDispAccount(false);
                                      }}
                                    >
                                      Change Password
                                    </Link>
                                  </li>
                                  <li className="account_logout_item">
                                    <Link
                                      to={`${process.env.PUBLIC_URL}/`}
                                      onClick={(e) => {
                                        setDispAccount(false);
                                        handleClick(e);
                                      }}
                                    >
                                      Logout
                                    </Link>
                                  </li>
                                </>
                              ) : (
                                <div className="account_guest_actions">
                                  <Link
                                    to={`${process.env.PUBLIC_URL}/login`}
                                    onClick={() => {
                                      setPageRoute("/login");
                                      setDispAccount(false);
                                    }}
                                    className="account_btn_signin"
                                  >
                                    Sign In
                                  </Link>
                                  <Link
                                    to={`${process.env.PUBLIC_URL}/register`}
                                    onClick={() => {
                                      setPageRoute("/register");
                                      setDispAccount(false);
                                    }}
                                    className="account_btn_register"
                                  >
                                    Register
                                  </Link>
                                </div>
                              )}
                            </ul>
                          </div>
                        )}
                      </div>
                    </li>

                    {/* Mobile Hamburger on FAR RIGHT */}
                    <li className="checkout_header1 mx-1 nav_hamburger_mobile_item">
                      <div
                        className="ancd ancx nav_hamburger_btn"
                        onClick={() => setShow(!show)}
                        role="button"
                        tabIndex={0}
                        aria-label="Toggle Menu"
                      >
                        <FaBars aria-hidden="true" />
                      </div>
                    </li>
                  </ul>
                  </div>

                  {/* ROW 2: Mobile Search Bar with live autocomplete */}
                  <div className="mobile_search_bar_row">
                    <NavbarSearch isMobile={true} />
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile overlay backdrop */}
      {show && (
        <div
          className="fs_menu_overlay_header1"
          style={{ background: "rgba(0,0,0,0.55)", pointerEvents: "all" }}
          onClick={() => setShow(false)}
        />
      )}

      <div
        className={
          show ? "hamburger_menu_header1 active" : "hamburger_menu_header1"
        }
      >
        {/* Drawer top bar: logo + close */}
        <div className="mobile-drawer-topbar">
          <Link to={`${process.env.PUBLIC_URL}/`} onClick={() => setShow(false)}>
            {sociallinks?.logo ? (
              <LazyLoadImage
                src={sociallinks.logo}
                alt="Logo"
                style={{ maxHeight: 40, width: "auto", objectFit: "contain" }}
              />
            ) : null}
          </Link>
          <div
            className="hamburger_close_header1"
            onClick={() => setShow(false)}
          >
            <FaTimes aria-hidden="true" />
          </div>
        </div>

        <div className="hamburger_menu_content_header1">
          <ul className="menu_top_nav">

            {/* Home */}
            <li className="mobile_nav_item">
              <div className="mobile_nav_row">
                <Link
                  to={`${process.env.PUBLIC_URL}/`}
                  className={`mobile_nav_link ${pageRoute === "/" ? "active" : ""}`}
                  onClick={() => {
                    setPageRoute("/");
                    setShow(false);
                  }}
                >
                  Home
                </Link>
              </div>
            </li>

            {/* All Products */}
            <li className="mobile_nav_item">
              <div className="mobile_nav_row">
                <Link
                  to={{
                    pathname: `/products/Products-all`,
                    state: { categories: {} },
                  }}
                  className={`mobile_nav_link ${pageRoute === "/products" ? "active" : ""}`}
                  onClick={() => {
                    setPageRoute("/products");
                    setShow(false);
                  }}
                >
                  All Products
                </Link>
              </div>
            </li>

            {/* Dynamic Categories */}
            {sortedCategories.map((m) => {
              const subs = subCategoriesMap[m.id] || [];
              const hasSubs = subs.length > 0;
              const isExpanded = expandedMobileCat === m.id;
              const catSlug = `/products/${m.name.replace(/\s+/g, "-")}-${m.id}`;
              const isCatActive = pageRoute.includes(catSlug);

              return (
                <li key={m.id} className="mobile_nav_item">
                  <div className="mobile_nav_row">
                    <Link
                      to={{
                        pathname: catSlug,
                        state: { categories: m },
                      }}
                      className={`mobile_nav_link ${isCatActive ? "active" : ""}`}
                      onClick={() => setShow(false)}
                    >
                      {m.name}
                    </Link>

                    {hasSubs && (
                      <div
                        className="mobile_arrow_toggle"
                        onClick={() =>
                          setExpandedMobileCat(isExpanded ? null : m.id)
                        }
                      >
                        <FaAngleDown
                          style={{
                            fontSize: "15px",
                            transition: "transform 0.3s ease",
                            transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                          }}
                        />
                      </div>
                    )}
                  </div>

                  {hasSubs && (
                    <ul
                      className="mobile_submenu"
                      style={{
                        maxHeight: isExpanded ? `${subs.length * 48}px` : 0,
                      }}
                    >
                      {subs.map((sub) => (
                        <li key={sub.id}>
                          <Link
                            to={{
                              pathname: `/products/${sub.name.replace(
                                /\s+/g,
                                "-",
                              )}-${sub.id}`,
                              state: { categories: sub },
                            }}
                            onClick={() => setShow(false)}
                          >
                            {sub.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              );
            })}

            {/* About */}
            <li className="mobile_nav_item">
              <div className="mobile_nav_row">
                <Link
                  to={`${process.env.PUBLIC_URL}/about-us`}
                  className={`mobile_nav_link ${pageRoute === "/about-us" ? "active" : ""}`}
                  onClick={() => {
                    setPageRoute("/about-us");
                    setShow(false);
                  }}
                >
                  About
                </Link>
              </div>
            </li>

            {/* Contact */}
            <li className="mobile_nav_item">
              <div className="mobile_nav_row">
                <Link
                  to={`${process.env.PUBLIC_URL}/contact`}
                  className={`mobile_nav_link ${pageRoute === "/contact" ? "active" : ""}`}
                  onClick={() => {
                    setPageRoute("/contact");
                    setShow(false);
                  }}
                >
                  Contact
                </Link>
              </div>
            </li>

            {/* My Account */}
            <li className="mobile_nav_item">
              <div
                className="mobile_nav_row"
                onClick={() => setShowA(!showA)}
                style={{ cursor: "pointer" }}
              >
                <span className="mobile_nav_link">My Account</span>
                <div className="mobile_arrow_toggle">
                  <FaAngleDown
                    style={{
                      fontSize: "15px",
                      transition: "transform 0.3s ease",
                      transform: showA ? "rotate(180deg)" : "rotate(0deg)",
                    }}
                  />
                </div>
              </div>
              <ul
                className="mobile_submenu"
                style={{
                  maxHeight: showA ? (localStorage.getItem("customerData") ? "190px" : "110px") : 0,
                }}
              >
                {localStorage.getItem("customerData") ? (
                  <>
                    <li>
                      <Link
                        to={`${process.env.PUBLIC_URL}/dashboard`}
                        onClick={() => {
                          setPageRoute("/dashboard");
                          setShow(false);
                        }}
                      >
                        Dashboard
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`${process.env.PUBLIC_URL}/myOrders`}
                        onClick={() => {
                          setPageRoute("/myOrders");
                          setShow(false);
                        }}
                      >
                        My Orders
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`${process.env.PUBLIC_URL}/ChangePassword`}
                        onClick={() => {
                          setPageRoute("/ChangePassword");
                          setShow(false);
                        }}
                      >
                        Change Password
                      </Link>
                    </li>
                    <li onClick={() => setShow(false)}>
                      <Link
                        onClick={handleClick}
                        to={`${process.env.PUBLIC_URL}/`}
                      >
                        Logout
                      </Link>
                    </li>
                  </>
                ) : (
                  <>
                    <li>
                      <Link
                        to={`${process.env.PUBLIC_URL}/login`}
                        onClick={() => {
                          setPageRoute("/login");
                          setShow(false);
                        }}
                      >
                        Sign In
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`${process.env.PUBLIC_URL}/register`}
                        onClick={() => {
                          setPageRoute("/register");
                          setShow(false);
                        }}
                      >
                        Register
                      </Link>
                    </li>
                  </>
                )}
              </ul>
            </li>

            {/* Currency */}
            {ChangeCurrences && ChangeCurrences.length > 0 && (
              <li className="mobile_nav_item">
                <div
                  className="mobile_nav_row"
                  onClick={() => setDispCurrence(!dispCurrunce)}
                  style={{ cursor: "pointer" }}
                >
                  <span className="mobile_nav_link">
                    {localStorage.getItem("changeCurrencies") || "Currency"}
                  </span>
                  <div className="mobile_arrow_toggle">
                    <FaAngleDown
                      style={{
                        fontSize: "15px",
                        transition: "transform 0.3s ease",
                        transform: dispCurrunce ? "rotate(180deg)" : "rotate(0deg)",
                      }}
                    />
                  </div>
                </div>
                <ul
                  className="mobile_submenu"
                  style={{
                    maxHeight: dispCurrunce ? `${ChangeCurrences.length * 48}px` : 0,
                  }}
                >
                  {ChangeCurrences.map((i, idx) => (
                    <li
                      key={idx}
                      onClick={() => {
                        localStorage.setItem("defaultDataaa", i?.code);
                        setDispCurrence(false);
                        localStorage.setItem("changeCurrencies", i?.code);
                        setShow(false);
                        window.location.reload();
                      }}
                    >
                      <a style={{ cursor: "pointer" }}>{i?.code}</a>
                    </li>
                  ))}
                </ul>
              </li>
            )}
          </ul>
        </div>
      </div>

      {drop ? "" : <div style={{ paddingBottom: "25px" }} />}
    </>
  );
};
function mapStateToProps(state) {
  return {
    getWishlists: state.wishlist.getwishlist
      ? state.wishlist.getwishlist.data
      : [],
    sociallinks: state.contactDetails.socialLinks,
    cartData: state.cartList.getcartdata ? state.cartList.getcartdata.data : "",
    mainScreenText: state?.user?.mainScreenText
      ? state?.user?.mainScreenText
      : "",
    currencies: state?.user?.currencies ? state?.user?.currencies : "",
    ChangeCurrences: state?.user?.changeCurrences
      ? state?.user?.changeCurrences
      : "",
    appconfigs: state?.user?.config ? state?.user?.config : "",
    categories: state.data.menu,
    getallcategories: state.data.getCategory,
  };
}
export default connect(mapStateToProps, null)(Header2);
